import React from "react";
import {Dropdown, DropdownButton, FormLabel, InputGroup} from "react-bootstrap";

function DropdownScope(props: { titleScope: string, scope: string, setScope: any, scopes: any }) {
  const {titleScope, scope, setScope, scopes} = props;
  const items = scopes.map((s: string) => {
      return (
        <Dropdown.Item key={`dropdown-scope-${s}`} onClick={() => setScope(s)}>
          {s}
        </Dropdown.Item>
      );
    }
  );

  function description() {
    if (scope === 'Admin') {
      return 'Admins can view and edit an organization and all Villas within an organization, invite new members, edit member access, and remove members';
    } else if (scope === 'Member') {
      return 'Members can view and visit all Villas within an organization, edit a Villa including the Mascot, and view and make themselves a member of all Villas within an organization';
    } else {
      return 'Guests can view and visit only the Villas to which they have been invited';
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <InputGroup>
            <FormLabel>{titleScope}&nbsp;</FormLabel>
            <Dropdown onClick={(e: any)=> e.stopPropagation()}>
              <DropdownButton key="dropdown-button" variant="secondary" menuAlign="left" title={scope}>
                {items}
              </DropdownButton>
            </Dropdown>
          </InputGroup>
        </div>
      </div>
      <div className="row">
        <div className="col">
          {description()}
        </div>
      </div>
    </>
  );
}

export default DropdownScope;
